import type { ComponentProps } from "react"
import {
  TRAVELTIME_START_POINT_PIN_BODY_PATH,
  TRAVELTIME_START_POINT_PIN_DOT_PATH,
  TRAVELTIME_START_POINT_PIN_FILL,
  TRAVELTIME_START_POINT_PIN_HOLE_PATH,
  TRAVELTIME_START_POINT_PIN_OUTLINE,
  TRAVELTIME_START_POINT_RINGS,
  type TraveltimeStartPointRings,
} from "@/v2-ui/icon/custom/traveltimeStartPoint/traveltimeStartPoint.constants"

export type TraveltimeStartPointProps = ComponentProps<"svg"> & {
  fill?: string
  /** One colour per ring, outer first; a ring without one takes `fill`. */
  ringColors?: readonly string[]
}

/**
 * A start point with its reach behind it: `fill` colours the rings (the
 * search's colour, as on the map), or `ringColors` one each, outer first;
 * the pin takes the theme's foreground on a background outline so the
 * same icon is right in light and dark.
 */
export function TraveltimeStartPoint(
  props: TraveltimeStartPointProps & { rings: TraveltimeStartPointRings },
) {
  const { fill = "currentColor", ringColors, rings, ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      {TRAVELTIME_START_POINT_RINGS[rings].map((ring, index) => (
        <path
          key={ring.d}
          d={ring.d}
          fill={ringColors?.[index] ?? fill}
          fillOpacity={ring.fillOpacity}
          stroke={ringColors?.[index] ?? fill}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      ))}
      <path
        d={TRAVELTIME_START_POINT_PIN_DOT_PATH}
        fill={TRAVELTIME_START_POINT_PIN_FILL}
        stroke={TRAVELTIME_START_POINT_PIN_OUTLINE}
      />
      <path
        d={TRAVELTIME_START_POINT_PIN_BODY_PATH}
        fill={TRAVELTIME_START_POINT_PIN_FILL}
        stroke={TRAVELTIME_START_POINT_PIN_OUTLINE}
        strokeWidth="1.498"
        strokeLinejoin="round"
      />
      <path
        d={TRAVELTIME_START_POINT_PIN_HOLE_PATH}
        fill={TRAVELTIME_START_POINT_PIN_OUTLINE}
      />
    </svg>
  )
}

export function TraveltimeStartPointSingle(props: TraveltimeStartPointProps) {
  return <TraveltimeStartPoint rings={1} {...props} />
}
export function TraveltimeStartPointDouble(props: TraveltimeStartPointProps) {
  return <TraveltimeStartPoint rings={2} {...props} />
}
export function TraveltimeStartPointTriple(props: TraveltimeStartPointProps) {
  return <TraveltimeStartPoint rings={3} {...props} />
}
export function TraveltimeStartPointQuadruple(
  props: TraveltimeStartPointProps,
) {
  return <TraveltimeStartPoint rings={4} {...props} />
}
